import styled from '@emotion/styled';
import { chromeHeight, pageLayoutV2Sizes } from './styles';

/**
 * 業務コンテンツの枠。
 *
 * 高さをここで与える。ヘッダーが占める高さを知っているのは shell の側なので、
 * 中に入る `MainAreaV2` は自分の高さを持たず、ここから受け取る作りにしてある。
 *
 * `position` は指定しない。移行前の画面は ppfw-client の `Template` のままで、`#view-area` の
 * 高さが `offsetTop` を基準に算出されるため、ここに位置指定の基準要素を作ると高さが過大に
 * 計算される。
 *
 * 余白は持たない。`MainAreaV2` はヘッダー・viewport 端に直接接し、内側の詰めだけで
 * 中身を離す。pp_bos_onboarding_front の `Template` の `main` と同じ構成で、外側に隙間を
 * 空けると、そこに ppfw-client の `globalStyle`（`body` に敷く `#eeeef2`）が透けて
 * メインエリアが card として浮いて見える。
 */
export const MainAreaSlotV2 = styled.div`
  flex: 1;
  height: calc(100vh - ${chromeHeight});
  min-width: ${pageLayoutV2Sizes.mainAreaMinWidth};
`;
